"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectUnpackerImpl = void 0;
var ReferencesResolver_1 = require("./ReferencesResolver");
var Util_1 = require("./Util");
var num_easy_log_1 = require("num-easy-log");
var instructions_1 = require("./instructions");
var ObjectUnpackerImpl = (function () {
    function ObjectUnpackerImpl() {
    }
    ObjectUnpackerImpl.prototype.convert = function (referencesObject, rawData, rawMapping) {
        try {
            var mapping = instructions_1.toInstructionSchema(rawMapping);
            var data = Util_1.transform(rawData, Util_1.prefixReferences);
            var dictionary = new Map();
            Util_1.indexObject(ReferencesResolver_1.INDEX_NAMESPACE, dictionary, data['?']);
            Util_1.indexObject(ReferencesResolver_1.COMPACT_NAMESPACE, dictionary, data);
            Util_1.indexObject(ReferencesResolver_1.SUBS_NAMESPACE, dictionary, referencesObject);
            var expanded = void 0;
            if (mapping.length === 0) {
                expanded = data;
                delete expanded['?'];
            }
            else {
                var e = {
                    stack: [
                        {
                            locals: {
                                '/compact': data,
                            },
                            result: null,
                        },
                    ],
                };
                instructions_1.createUnpacker(mapping)(e);
                expanded = e.stack[0].locals['/expanded'];
            }
            return referencesResolver.resolve(dictionary, expanded);
        }
        catch (e) {
            num_easy_log_1.log.error(e.message);
            return { error: e.message };
        }
    };
    return ObjectUnpackerImpl;
}());
exports.ObjectUnpackerImpl = ObjectUnpackerImpl;
var referencesResolver = ReferencesResolver_1.createReferencesResolver();
//# sourceMappingURL=ObjectUnpackerImpl.js.map